// Currency symbols mirror backend list; used for client-side formatting fallback.
const SYMBOLS = {
    USD: "$", EUR: "€", GBP: "£", AUD: "A$", NZD: "NZ$", CAD: "C$", CHF: "CHF",
    JPY: "¥", CNY: "¥", INR: "₹", AED: "د.إ", SGD: "S$", HKD: "HK$", ZAR: "R",
    BRL: "R$", MXN: "MX$", SEK: "kr", NOK: "kr", DKK: "kr", PLN: "zł", PHP: "₱",
    MYR: "RM",
};

export const currencySymbol = (code) => SYMBOLS[code] || code;

export const formatMoney = (amount, code = "USD") => {
    const sym = SYMBOLS[code] || code + " ";
    const n = Number(amount || 0);
    if (code === "JPY") return `${sym}${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
    return `${sym}${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Alias used by newer components
export const money = formatMoney;

export const statusLabel = (s) => ({
    draft: "Draft",
    sent: "Sent",
    accepted: "Accepted",
    declined: "Declined",
    modification_requested: "Mod. Requested",
}[s] || s);

export const statusColor = (s) => ({
    draft: "bg-slate-100 text-slate-700 border-slate-200",
    sent: "bg-sky-50 text-sky-700 border-sky-200",
    accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
    declined: "bg-rose-50 text-rose-700 border-rose-200",
    modification_requested: "bg-amber-50 text-amber-800 border-amber-200",
}[s] || "bg-slate-100 text-slate-700 border-slate-200");
